import { render, staticRenderFns } from "./auth.layout.vue?vue&type=template&id=e10a875c&scoped=true"
import script from "./auth.layout.vue?vue&type=script&lang=js"
export * from "./auth.layout.vue?vue&type=script&lang=js"
import style0 from "./auth.layout.vue?vue&type=style&index=0&id=e10a875c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e10a875c",
  null
  
)

export default component.exports